
export default class NumberUtils {
  
    static countDecimals(value: number) {
        if(Math.floor(value.valueOf()) === value.valueOf()) return 0;
        const splitNumber = value.toString().split(".")
        if (splitNumber.length === 1) return 0;
        //console.log(value.toString().split(".")[1].length || 0)
        return value.toString().split(".")[1].length || 0; 
    }
}